import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { SharedService } from '../../shared.service';
import * as moment from 'moment-timezone';

@Component({
  selector: 'vex-info-hints',
  templateUrl: './info-hints.component.html',
  styleUrls: ['./info-hints.component.scss'],
  encapsulation : ViewEncapsulation.None
})
export class InfoHintsComponent implements OnInit {

  api_load_error_message:string;
  api_load_error:boolean=false;
  page_auth_err:boolean=false;
  page_auth_err_message:string;

  dialog_message:any;
  api_call:boolean=false;
  header_title:any;
  dialog_class:string;
  spinner_class:string;
  api_call_mesage:string;
  mat_dialog_spinner_color:string;
  close_cancel:string;
  yes_confirm:string;
  success_delete:boolean=true;
  show_yes_confirm:boolean=true;
  
  search_text: string;

  is_update_err:boolean=false;
  field_errors:any;
  close_dialog_status:any={};

  auth_key:any;

  constructor(
    public dialog_hints:MatDialogRef<InfoHintsComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_hints_data,
	  private shared_service:SharedService,
    public router:Router,
    private route: ActivatedRoute,

  ) { }

  ngOnInit(): void {

    this.api_call = true;
    this.shared_service.getAuthKey.subscribe(auth_key =>{
      this.auth_key=auth_key;
      this.getHints();
    });

    this.header_title='Explaination';
    this.dialog_class="task-header-gray";
    this.close_cancel="Close";
    this.yes_confirm="Yes";
    this.spinner_class="cfm-hint-spinner";
    this.api_call_mesage ="Processing ...";
    this.dialog_message=this.dialog_hints_data.content;

    
  }

  getHints(){

    this.api_call = true;
   
    var data = {
      device_type:"Web",
      device_os:"Web",
      device_unique_id:"",
      device_other_details:"",
      device_token:"",
      app_name:environment.app_name,
      api_at:moment().unix(),
      api_at_tz:moment.tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format('Z'),
      api_datetime:moment().format('YYYY-MM-DD HH:mm:ss'),
      info_hints:this.dialog_hints_data
      
    }

    let enc_data = this.shared_service.encrypt(this.auth_key,JSON.stringify(data))


    var formData = new FormData();
      
    formData.append('data', enc_data);
    

    this.shared_service.getInfoHints(formData).subscribe(
      (serverResponse) => {
        
        if(serverResponse.err_type == 0){
             
          let info_hints = this.shared_service.decrypt(this.auth_key,serverResponse.payload);

          if(info_hints.info_hints == null){
          
            this.dialog_message='NO Info Available for : "'+this.dialog_hints_data+ '"';
     
          }else{
            this.dialog_message=info_hints.info_hints.description;    
          }
        
          this.api_call=false;
          
        }else{

        }

    })
  }

  close(){

    this.dialog_hints.close(this.close_dialog_status);
  }

}
